import { z } from 'zod';
import { severitySchema } from './shared/severity';
/**
 * Slack settings response schema
 */
export const slackSettingsResponseSchema = z.object({
    id: z.string(),
    enabled: z.boolean(),
    webhookUrl: z.string(), // Masked in response
    minRiskLevel: severitySchema,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
/**
 * Upsert Slack settings request schema
 */
export const upsertSlackSettingsBodySchema = z.object({
    enabled: z.boolean(),
    webhookUrl: z
        .string()
        .url('Invalid webhook URL')
        .startsWith('https://hooks.slack.com/', 'Must be a valid Slack webhook URL'),
    minRiskLevel: severitySchema,
    sendTestMessage: z.boolean().optional().default(false),
});
/**
 * Upsert Slack settings response schema
 */
export const upsertSlackSettingsResponseSchema = slackSettingsResponseSchema.extend({
    testMessageSent: z.boolean(),
});
//# sourceMappingURL=slack-settings.js.map